import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";



export default function Salobo(){

  return(

    <>
    <Helmet title="Projeto Salobo Metais - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="PROJETO SALOBO METAIS" link1={"Projetos/ "} link2={"PROJETO SALOBO METAIS"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                    PROJETO SALOBO METAIS
                </h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Construção de obras civis prediais, com fornecimento de mão-de-obra e materiais, para as unidades da Vale e Salobo Metais, com abrangência nos municípios de Parauapebas – PA e Marabá – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
                <h2>Informações do Projeto</h2>
                <ul>
                  <li><strong>Cliente: </strong> Vale</li>
                  <li><strong>Cidade: </strong> Parauapebas / Marabá - PA</li>
                  <li><strong>Ano: </strong> 2021 </li>
                  <li><strong>Segmento: </strong> Engenharia Civil </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />

      <Ouvidoria/>
    </>
  )
}